"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinalRender = exports.Triangle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Triangle = _styledComponents["default"].div.withConfig({
  displayName: "Elements__Triangle",
  componentId: "y6eu4c-0"
})(["position:absolute;transform:rotate(45deg);height:8px;width:8px;background:#fff;z-index:2000;border-color:transparent #fff #fff transparent;"]);

exports.Triangle = Triangle;

var FinalRender = _styledComponents["default"].div.withConfig({
  displayName: "Elements__FinalRender",
  componentId: "y6eu4c-1"
})(["position:absolute;box-shadow:0 3px 6px -4px rgba(0,0,0,.12),0 6px 16px 0 rgba(0,0,0,.08),0 9px 28px 8px rgba(0,0,0,.05);border-radius:2px;padding:10px;background:white;z-index:2000;"]);

exports.FinalRender = FinalRender;